module.exports = __webpack_public_path__ + "assets/img/trade1.d7e5da31.png";